import React from "react";
import * as Icons from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { useLang } from "@/i18n";
import { homeQueryKey, fetchHome } from "@/lib/queries";

const FALLBACK = [
  { icon: "BadgeCheck", fr: "PRODUITS AUTHENTIQUES", en: "AUTHENTIC PRODUCTS" },
  { icon: "MapPin", fr: "DISPONIBLE À TRAVERS LES ÉTATS-UNIS", en: "AVAILABLE ACROSS THE UNITED STATES" },
  { icon: "ShieldCheck", fr: "PAIEMENTS SÉCURISÉS", en: "SECURE PAYMENTS" },
  { icon: "Sparkles", fr: "100% PRODUITS HAÏTIENS", en: "100% HAITIAN PRODUCTS" },
  { icon: "Heart", fr: "PWODWI LAKAY", en: "PWODWI LAKAY" },
  { icon: "Truck", fr: "LIVRAISON FIABLE", en: "RELIABLE DELIVERY" },
];

// Business Solutions is hidden from the public site for now — filter it out even if a stale record still exists in the CMS.
const isBusinessItem = (it) => /business/i.test(it?.en || "") || /business/i.test(it?.fr || "");

export default function BenefitMarquee() {
  const { lang } = useLang();
  const { data } = useQuery({ queryKey: homeQueryKey, queryFn: fetchHome });
  const marquee = (data?.content?.marquee || []).filter((it) => !isBusinessItem(it));
  const items = marquee.length ? marquee : FALLBACK;
  const loop = [...items, ...items];
  return (
    <section className="marquee-wrap relative overflow-hidden border-y border-gold/20 bg-navy py-4" data-testid="benefit-marquee" aria-label="benefits">
      <div className="marquee-track">
        {loop.map((it, i) => {
          const Icon = Icons[it.icon] || Icons.Star;
          return (
            <div key={i} className="flex items-center gap-3 px-8" aria-hidden={i >= items.length}>
              <Icon size={18} className="shrink-0 text-gold" />
              <span className="whitespace-nowrap font-head text-sm font-semibold uppercase tracking-[0.18em] text-cream">{lang === "fr" ? it.fr : it.en}</span>
              <span className="ml-8 h-1.5 w-1.5 rounded-full bg-sunset" />
            </div>
          );
        })}
      </div>
    </section>
  );
}
